import React from 'react';
import '../../css/common/ApplicationStatus.css';

const ApplicationStatus = ({ status, className = '' }) => {
  const getStatusDisplay = (status) => {
    switch (status) {
      case 'open':
        return { text: 'Applications Open', className: 'application-status-open' };
      case 'closed':
        return { text: 'Applications Closed', className: 'application-status-closed' };
      case 'coming-soon':
        return { text: 'Coming Soon', className: 'application-status-coming-soon' };
      default:
        return { text: 'Applications Closed', className: 'application-status-closed' };
    }
  };

  const statusInfo = getStatusDisplay(status);

  return (
    <span className={`application-status ${statusInfo.className} ${className}`}>
      {statusInfo.text}
    </span>
  );
};

export default ApplicationStatus; 